export const redirectOnlyForAgentInternText = `As an Agent Intern, your agent domain site will redirect to www.statefarm.com until you appoint. Because of this, upgrading to M1 or M2 will be disabled until that time.`;

export const productTypes = {
	parked: {
		product_type: 'parked',
		title: 'Parked',
		subtitle: 'Secure Parked Domain',
		initials: 'PK',
		badgeColor: 'green',
		highlight: false,
		listHeading: 'Parked Domain Redirects',
		allowIntern: true,
		buttonText: 'Get a Parked Domain',
		disabledMessage:
			'You must have at least one other type of domain in your account before you can purchase a Parked domain.',
		demoUrl: 'https://mirus-dev-alpha.com',
		features: [
			{ description: 'Secured 301 redirect to another domain in your account' },
			{
				description: 'Email redirects available for an additional $1 each /month',
			},
			{
				description: 'A great way to compliantly reserve a domain name for later use',
			},
		],
		notes: [
			'Not compatible for use with Search Engine Marketing / Google Adwords',
			'Requires a Proxied, M1, or M2 for the redirect destination',
		],
		price: '13',
		description:
			'A Secure Parked Domain will redirect all visitors to one of your secure domains. Email Redirects are $1/mo. each',
	},
	sf_microsite: {
		product_type: 'sf_microsite',
		title: 'Proxied',
		subtitle: 'Secure Proxied Domain & Email',
		initials: 'PM',
		badgeColor: 'red',
		highlight: false,
		listHeading: 'Proxied SF Microsites',
		allowIntern: true,
		buttonText: 'Get a Proxied Domain',
		disabledMessage: null,
		demoUrl: 'https://1001ships.com',
		features: [
			{
				description:
					'A secure, standalone domain which mirrors, or “proxies”, your State Farm Microsite (the long statefarm.com url)',
			},
			{
				description: 'Suitable for Search Engine Marketing / Google Adwords',
			},
			{
				description: 'Free, unlimited email redirects',
			},
			{
				description:
					'Quote Landing Pages (in both English and Spanish, if your office is Spanish enabled)',
			},
			{
				description: 'Landing page and SEM campaign tracking stats',
			},
		],
		notes: null,
		price: '19',
		description: 'A Secure Proxied Domain will mirror the content of your SF Microsite.',
	},
	m1: {
		product_type: 'm1',
		title: 'M1',
		subtitle: 'Marketing Website & Email',
		initials: 'M1',
		badgeColor: 'orange',
		highlight: false,
		listHeading: 'M1 - Entry Level Marketing Domains',
		allowIntern: false,
		buttonText: 'Get an M1 Domain',
		disabledMessage: null,
		demoUrl: 'https://superflyagentguy.com/',
		features: [
			{
				description:
					'A single, secure, customizable web-page which includes all the essentials for marketing your office online:',
				extraPoints: [
					'Address',
					'Phone number(s)',
					'Team member information',
					'Contact form',
					'Current job listings',
					'And much more!',
				],
			},
			{
				description: 'Suitable for Search Engine Marketing / Google Adwords',
			},
			{
				description: 'Custom photo opportunities for yourself and your team',
			},
			{
				description: 'Real time compliance checks on text updates',
			},
			{ description: 'Free and unlimited email redirects' },
			{
				description:
					'Quote Landing Pages (in both English and Spanish, if your office is Spanish enabled)',
			},
			{ description: 'Landing page and SEM campaign tracking stats' },
		],
		notes: null,
		price: '29',
		description: 'A highly customizable single-page marketing website.',
	},
	m2: {
		product_type: 'm2',
		title: 'M2',
		subtitle: 'Advanced Marketing Website & Email',
		initials: 'M2',
		badgeColor: 'blue',
		highlight: 'Most Popular',
		listHeading: 'M2 - Advanced Marketing Domains',
		allowIntern: false,
		buttonText: 'Get an M2 Domain',
		disabledMessage: null,
		buttonColor: 'primary',
		demoUrl: 'https://myawesomeagency.com/',
		features: [
			{
				description:
					'A secure, customizable, multiple page website that offers all the essential office information of M1 on the homepage',
			},
			{
				description: 'Suitable for Search Engine Marketing / Google Adwords',
			},
			{
				description:
					'Insurance product pages which update automatically with prewritten, unique, compliant content',
			},
			{
				description: 'Google Reviews and Review links',
			},
			{
				description: 'Job openings with Apply Now capabilities',
			},
			{
				description:
					'Satellite/CSSO/Second Office location for agents whose legacy/MOA has an additional location',
			},
			{
				description: 'Additional custom photo areas',
			},
			{
				description: 'Real time compliance checks for text updates',
			},
			{
				description:
					'More customization opportunities than M1, with very little extra effort',
			},
			{
				description: 'Free and unlimited email redirects',
			},
			{
				description:
					'Quote Landing Pages (in both English and Spanish, if your office is Spanish enabled)',
			},
			{
				description: 'Landing page and SEM campaign tracking stats',
			},
		],
		notes: null,
		price: '54',
		description:
			'Our most advanced multi-page customizable marketing site with upgraded designs and layout.',
	},
};
